import { createContext, useContext } from "react";
import IDialog from "../ui/common/dialog_window/IDialog";
import IAlert from "../ui/common/alert_message/IAlert";
import IGroupExplore from "../ui/common/group_explore/IGroupExplore";

export interface IAlertsManager {
  showAlertMessage(params: IAlert): void;
  showDialogWindow(params: IDialog): void;
  showGroupExplore(params: IGroupExplore): void;
}

const AlertsContext = createContext<IAlertsManager | undefined>(undefined);

const useAlerts = (): IAlertsManager => {
  return useContext(AlertsContext) as IAlertsManager;
};

interface AlertsProviderProps {
  value: IAlertsManager;
  children: JSX.Element;
}

const AlertsProvider = ({
  value,
  children,
}: AlertsProviderProps): JSX.Element => {
  return (
    <AlertsContext.Provider value={value}>{children}</AlertsContext.Provider>
  );
};

export { AlertsProvider, useAlerts };
